/* Authentication renewal - token expiration */
export const SYNCHRONIZATION_ERROR_CORRECTION = 300
export const SHOW_ALERT_FROM = 300

export const DEFAULT_MIN_MAX_YEARS_FROM_TODAY = 100
